<template>
  <div class="more-info">
    <div v-if="obj.contacts.length > 0" class="items">
      <img src="../assets/imgs/10/now.png" @click="call" alt="" />
    </div>
    <div
      v-if="
        obj.processingMethod === 1 ||
        obj.processingMethod === 2 ||
        obj.processingMethod === 3
      "
      class="items"
    >
      <img src="../assets/imgs/10/call.png" @click="now" alt="" />
    </div>
  </div>
</template>

<script>
import { copy } from "clipboard";

export default {
  name: "",
  props: ["obj"],
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    async now() {
      switch (this.obj.processingMethod) {
        case 1:
          wx.miniProgram.redirectTo({
            url: `/pages/middlePage/index?data=${encodeURIComponent(
              JSON.stringify({
                path: this.obj.reportUrl,
                appid: this.obj.weChatAppId,
              })
            )}`,
          });
          break;
        case 2:
          const { data } = await this.$verifyUrl(this.obj.reportUrl);
          if (data.recordState) {
            window.location.href = this.obj.reportUrl;
          } else {
            copy(this.obj.reportUrl);
            this.$toast("已复制到剪切板,请从浏览器打开");
          }
          break;
        case 3:
          copy(this.obj.reportUrl);
          this.$toast("已复制到剪切板,请从浏览器打开");
          break;
      }

      // if (this.site) {
      //   window.location.href = this.site;
      // } else {
      //   this.$toast("暂未开放线上办理，可拨打电话咨询");
      // }
    },
    call() {
      window.location.href =
        "tel:" + this.obj.contacts[0].contactInformation.split(",")[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.more-info {
  z-index: 9999;
  position: fixed;
  right: 50%;
  transform: translateX(53%);
  bottom: 5%;
  display: flex;
  .items {
    width: 2.32rem;
    height: 0.8rem;
    background-color: #006cff;
    display: flex;
    border-radius: 26px;
    margin-right: 0.4rem;
    box-shadow: 1px 1px 3px #006cff, -1px -1px 3px #006cff;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
